import { ScopeContext } from '@sentry/types';

import React from 'react';

import { toSxArray } from '_lib/utils/helpers';

import { reportException } from '../../utils/sentryService';

import { ErrorBoundaryFallback, ErrorBoundaryFallbackProps } from '../ErrorBoundaryFallback/ErrorBoundaryFallback';

export interface RecoverableErrorState {
  error?: unknown;
  /**
   * Human readable message for the error
   */
  message?: string;
  /**
   * whether or not the error should be reported when caught
   * @default false
   */
  shouldReport?: boolean;
}

interface ManualErrorBoundaryProps extends Omit<ErrorBoundaryFallbackProps, 'title'> {
  errorState?: RecoverableErrorState;
  /**
   * Additional information to log
   */
  reportingCtx?: Partial<ScopeContext>;
}

export const ManualErrorBoundary = (props: ManualErrorBoundaryProps): React.ReactElement => {
  const { errorState, onRefresh, reportingCtx, sx, titleVariant } = props;

  if (errorState?.shouldReport && errorState?.error !== undefined) {
    reportException(errorState.error, reportingCtx);
  }

  return (
    <ErrorBoundaryFallback
      onRefresh={onRefresh}
      title={errorState?.message || 'Unknown Error'}
      sx={[{ position: 'relative' }, ...toSxArray(sx)]}
      titleVariant={titleVariant}
    />
  );
};
